import { loadingReducer } from "./reducer";
export default loadingReducer;
